import { render, staticRenderFns } from "./costRing.vue?vue&type=template&id=45939f7e&scoped=true"
import script from "./costRing.vue?vue&type=script&lang=js"
export * from "./costRing.vue?vue&type=script&lang=js"
import style0 from "./costRing.vue?vue&type=style&index=0&id=45939f7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45939f7e",
  null
  
)

export default component.exports